import { actionTypes } from '../actions/menor.gestao.action';
const initialState = {
    cotas: [],
    cota: {},
    result: {
        cota: {},
        transaction: {},
        user: {}
    },
    error: {},
    success: false
}

const MenorGestaoReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.cotas.data.findIndex(item => item.id === payload.id)
        state.cotas.data[index] = payload

        return {
            ...state,
            cotas: {
                ...state.cotas,
                data: [
                    ...[(index < 0) && payload],
                    ...state.cotas.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            cotas: state.cotas.filter(item => item.id !== payload)
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            cota: (payload === 'clear') ? {} : {
                ...state.cota,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default MenorGestaoReducer